input:focus {
  box-shadow: var(--shadow-focus-primary);
  outline: none !important;
}

:host {
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

.digits-container {
  display: flex;
  justify-content: flex-start;
}

input {
  width: calc(var(--space-unit) * 5);
  height: 72px;
  box-sizing: border-box;
  padding: 0;
  caret-color: transparent;
  color: var(--color-surface05);
  font-family: var(--font-family-sans);
  font-size: 32px;
  font-weight: 300;
  text-align: center;
}

input.error {
  border: 1px solid;
  border-color: var(--color-default-error);
  background-color: var(--color-inverse-error);
  border-radius: 4px;
}

input:not(:last-of-type) {
  margin-right: var(--space-unit);
}

/* Tablet breakpoint */
@media only screen and (min-width: 768px) {
  input:not(:last-of-type) {
    margin-right: calc(var(--space-unit) * 2);
  }
}

/* Desktop breakpoint */
@media only screen and (min-width: 1025px) {
  input {
    width: calc(var(--space-unit) * 6);
  }
}
